import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';
import { ApportionmentByCostCenterService } from './apportionment-by-cost-center.service';
import { YearMonth } from '@financial/arch';
import * as moment from 'moment';
import { ApportionmentByCostCenter } from '@financial/domain';

@Component({
  selector: 'app-apportionment-by-cost-center',
  templateUrl: './apportionment-by-cost-center.component.html',
  styleUrls: ['./apportionment-by-cost-center.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApportionmentByCostCenterComponent implements OnInit, OnChanges {

  @Input() selectedDate: Date = new Date();

  apportionments: ApportionmentByCostCenter[] = [];

  chartData: any[] = [];

  colorScheme = {
    domain: [
      '#f44336',
      '#ff8c00',
      '#fdb606',
      '#8BC34A',
      '#009688',
      '#2196F3'
    ]
  };

  view: [number, number] = [null, 330];

  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = true;
  showXAxisLabel = false;
  showYAxisLabel = false;
  legendPosition = 'below';

  constructor(
    private apportionmentByCostCenterService: ApportionmentByCostCenterService,
    private changeDetection: ChangeDetectorRef
  ) {
  }

  ngOnInit() {
    this.fetchData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedDate && !changes.selectedDate.firstChange) {
      this.fetchData();
    }
  }

  private fetchData() {
    const yearMonth = YearMonth.fromMoment(moment(this.selectedDate));

    this.apportionmentByCostCenterService.findBy(yearMonth).subscribe(
      result => {
        if (result && result.length > 0) {

          this.apportionments = result;

          this.chartData = [
            {
              name: moment(this.selectedDate).format('MM/YYYY'),

              series: result.map(item => {
                return {
                  name: item.costCenter,
                  value: item.value
                };
              })
            }
          ];
        } else {
          this.apportionments = [];
          this.chartData = [];
        }

        this.changeDetection.markForCheck();
      },
      (error) => console.log(error)
    );
  }
}
